import { render, staticRenderFns } from "./RecycleStepTable.vue?vue&type=template&id=6f65b385&scoped=true&"
import script from "./RecycleStepTable.vue?vue&type=script&lang=js&"
export * from "./RecycleStepTable.vue?vue&type=script&lang=js&"
import style0 from "./RecycleStepTable.vue?vue&type=style&index=0&id=6f65b385&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65b385",
  null
  
)

export default component.exports